import { Box, Grid, Typography, Link, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import CustomNumberField from "src/components/uiElements/form/customNumberField";
import { CustomPrimaryButtonFixed } from "src/components/uiElements/buttons/primaryButtonFixed";
import VerifyOtpScreen from "src/screens/outerScreens/verify_otp/verifyOtpScreen";
import SignInScreen from "src/screens/outerScreens/signin/signInScreen";
import SignUpScreen from "src/screens/outerScreens/signup/signUpScreen";
import UseForgotPassword from "./useForgotPassword";
import { OTPModal } from "src/components/modal/otpModal";
import PasswordResetSuccessScreen from "../password_reset_success/passwordResetSuccessScreen";

const ForgotPasswordScreen = () => {
  const {
    onSubmit,
    result,
    formContext,
    loading,
    isShowOTPModal,
    errorMessage,
    isError,
    verify_OTP,
    setIsShowOTPModal,
    isPasswordResetSuccess,
  } = UseForgotPassword();

  const { handleSubmit } = formContext;

  const [isSignInOpen, setIsSignInOpen] = useState(false);
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(true);
  const [isVerifyOtpScreenOpen, setIsVerifyOtpScreenOpen] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");

  useEffect(() => {
    if (result?.IsOTPSent) {
      setMobileNumber(result.MobileNumber);
      setIsVerifyOtpScreenOpen(true);
      setIsForgotPasswordOpen(false);
      setIsShowOTPModal(false);
    }
    if (isPasswordResetSuccess) {
      setIsVerifyOtpScreenOpen(false);
    }
  }, [result, isPasswordResetSuccess]);

  const handleSignInOpen = () => {
    setIsSignInOpen(true);
    setIsForgotPasswordOpen(false);
  };
  const handleOtpOpen = () => {
    setIsForgotPasswordOpen(false);
    setIsVerifyOtpScreenOpen(true);
  };
  const handleSignUpOpen = () => {
    setIsSignUpOpen(true);
    setIsForgotPasswordOpen(false);
  };
  const handleButtonClick = async (e: any) => {
    e.preventDefault();
    handleSubmit(onSubmit)();
  };

  return (
    <>
      {!isPasswordResetSuccess && (
        <>
          {isForgotPasswordOpen && (
            <FormProvider {...formContext}>
              <form
                onSubmit={handleSubmit(onSubmit)}
                noValidate
                style={{ width: "100%", padding: "30px" }}
              >
                <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="end"
                  justifyContent="end"
                  sx={{ marginTop: "15px" }}
                >
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        overflow: "hidden",
                        "@media (max-width: 768px)": {
                          width: "100%",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          padding: "0px",
                        }}
                      >
                        <Box sx={{ textAlign: "left" }}>
                          <img
                            src="/logo_b.png"
                            width={"170"}
                            style={{ display: "inline" }}
                          />
                        </Box>
                        <Typography
                          variant="h5"
                          sx={{
                            color: "#000000",
                            textTransform: "titlecase",
                            fontWeight: "600",
                            fontSize: "24px",
                            textAlign: "left",
                            marginTop: "20px",
                            marginBottom: "0px",
                          }}
                        >
                          Forgot Password
                        </Typography>
                        <Typography
                          variant="h5"
                          sx={{
                            fontSize: "16px",
                            fontWeight: "300",
                            color: "#000000",
                            textAlign: "left",
                            marginBottom: "20px",
                          }}
                        >
                          Enter your details to get OTP
                        </Typography>

                        <Grid
                          container
                          spacing={1}
                          sx={{
                            justifyContent: "center",
                          }}
                        >
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <CustomNumberField
                              name={"MobileNumber"}
                              size="small"
                              label={"UserName"}
                              placeholder="Ex. 9800000000"
                              length={10}
                            />
                            <small style={{ color: "#797979" }}>
                              Enter your registered mobile for OTP
                            </small>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            sx={{
                              textAlign: "end",
                              fontWeight: 300,
                              fontSize: "14px",
                              color: "#000000",
                            }}
                          >
                            If you have an account?
                            <Link
                              onClick={handleSignInOpen}
                              sx={{
                                textDecoration: "none",
                                fontSize: "14px",
                                color: "#6A0DAD",
                                fontWeight: 300,
                                marginLeft: "5px",
                                cursor: "pointer",
                                "&:hover": {
                                  color: "#000000",
                                },
                              }}
                            >
                              <span style={{ textDecoration: "underline" }}>
                                Sign In
                              </span>
                            </Link>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            style={{
                              alignItems: "center",
                              display: "grid",
                            }}
                            sx={{ mt: "14px" }}
                          >
                            <CustomPrimaryButtonFixed
                              onClick={handleButtonClick}
                              loading={loading}
                              title="SUBMIT"
                              // onClick={handleOtpOpen}
                              style={{
                                fontSize: "20px",
                                fontWeight: 500,
                                width: "100%",
                                justifySelf: "center",
                              }}
                            />
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            sx={{
                              fontWeight: 300,
                              fontSize: "14px",
                              textAlign: "center",
                              marginTop: "10px",
                              display: "none",
                            }}
                          >
                            If you are not an user
                            <Link
                              onClick={handleSignUpOpen}
                              sx={{
                                textDecoration: "none",
                                fontSize: "14px",
                                color: "#000",
                                marginLeft: "5px",
                                fontWeight: 300,
                                cursor: "pointer",
                                "&:hover": {
                                  color: "#0CA93E",
                                },
                              }}
                            >
                              <span style={{ textDecoration: "underline" }}>
                                Register Now?
                              </span>
                            </Link>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </form>
            </FormProvider>
          )}
        </>
      )}
      {isSignInOpen && <SignInScreen />}

      {isVerifyOtpScreenOpen && (
        <VerifyOtpScreen
          mobileNumber={mobileNumber}
          onOtpSubmit={async (values) => {
            const success = await verify_OTP(values);
            if (success) {
              setIsVerifyOtpScreenOpen(false);
              setIsForgotPasswordOpen(false);
            }
            return success;
          }}
          onBack={() => {
            setIsVerifyOtpScreenOpen(false);
            setIsForgotPasswordOpen(true);
            formContext.setValue("MobileNumber", mobileNumber);
          }}
        />
      )}

      {isSignUpOpen && <SignUpScreen />}
      {/* {isShowOTPModal && (
        <OTPModal
          isOpen={isShowOTPModal}
          title="Verify OTP"
          isError={isError}
          errorMessage={errorMessage}
          request={result}
          positiveButtonClick={async (value) => {
            await verify_OTP(value);
          }}
          negativeButtonClick={(value) => {
            setIsShowOTPModal(false);
          }}
        />
      )} */}
      {isPasswordResetSuccess && <PasswordResetSuccessScreen />}
    </>
  );
};

export default ForgotPasswordScreen;
